import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { useMaintenanceRolePermissions } from "../hooks/useMaintenanceRolePermissions";
import {
  buildMaintenancePermissions,
  buildMaintenancePermissionsForScreen,
} from "./maintenancePermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

/** Staff maintenance permissions for a screen slug (control or records). */
export function useMaintenanceRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permLoading,
    error: permissionsError,
  } = useMaintenanceRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildMaintenancePermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildMaintenancePermissions(permissions);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
